import { Button } from 'src/components';
import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: grid;
  height: 100vh;

  div {
    max-width: 600px;
    text-align: center;
    grid-column-start: 2;
    grid-row-start: 2;

    > img {
      width: 350px;
      margin-bottom: 10%;
    }
  }
`;

export const ErrorText = styled.div`
  font-size: 14pt;
  margin-bottom: 16px;
`;

export const ErrorTitle = styled.h1`
  margin-bottom: 60px;
  font-size: 26pt;
  font-weight: bold;
`;

export const SubscribeButton = styled(Button)`
  margin-top: 16px;
`;

export const StripeBadge = styled.img`
  max-width: 100px;
  float: right;
`;
